import { useState } from 'react'

import { Users } from '~services'
import { UserData } from '~services/interfaces'
import { useRequest } from 'ahooks'

const useUser = () => {
  const [userData, setUserData] = useState<UserData>(null)

  useRequest(Users.getUserData, { onSuccess: (response) => setUserData(response?.data) })

  return userData
}

export default useUser